import { categories } from '../data/check-in-questions';

import { cn } from '@/lib/utils';

interface CategoryTabsProps {
  value: string;
  onChange: (value: string) => void;
}

const allOptions = [{ id: 'all', label: 'All' }, ...categories];

export function CategoryTabs({ value, onChange }: CategoryTabsProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Filter by category"
      className="inline-flex h-10 w-full flex-wrap items-center justify-center rounded-md bg-muted p-1 text-muted-foreground"
    >
      {allOptions.map((opt) => (
        <button
          key={opt.id}
          type="button"
          role="radio"
          aria-checked={value === opt.id}
          onClick={() => onChange(opt.id)}
          className={cn(
            'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium text-foreground/70 ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            value === opt.id && 'bg-background text-foreground shadow-sm',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
